import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getAdminVacancyAPI from '../../api/get-admin-vacancy';
import { clearFromHTML } from '../../utils/clear-html';
import { ICompactVacancy } from '../../utils/types/state-types';
import { receiveAdminVacancies, rejectAdminVacancies, requestAdminVacancies } from '../actions/admin-page';

interface IGetVacancyAction {
  type: string;
  payload: {
    mode: 'compact' | 'normal';
    searchValue: string;
    group: string;
    division: string;
  }
}

const getAdminVacancies = function* getAdminVacancies(action: IGetVacancyAction) {
  try {
    const response: ICompactVacancy[] = yield call(
      getAdminVacancyAPI,
      action.payload.mode,
      action.payload.group,
      action.payload.searchValue,
      action.payload.division,
    );
    yield put(receiveAdminVacancies({
      groupVacancies: response.map((item) => ({
        ...item,
        title: clearFromHTML(item.title),
      })),
    }));
  } catch (error) {
    yield put(rejectAdminVacancies({ error }));
  }
};

export default function* getAdminVacanciesWatcher() {
  yield takeLatest(requestAdminVacancies, getAdminVacancies);
}
